/**
 * Created by Mark on 01/12/2016.
 */


import React from "react";
import TableHeader from "./table.header.component.js";
import TableBody   from "./table.body.component.js";
import TableSearchComponent from "./table.search.component.js";
import { FormattedMessage } from 'react-intl';
import Download from '../../classes/download.js';

export default class TableControlsComponent extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.preventEvent = false;
        this.state = {
            enableSearch:true,
            enableActions:props.enableActions !== false ? true : false,
            onSearch:props.onSearch || null,
            columns: props.columns  || null,
            csvArr: props.csvArr || [],
            toggle:false,
            onColumnsUpdate:props.onColumnsUpdate || function(){},
            additionalButtons: props.additionalButtons || []
        }
    }

    show() {
        document.removeEventListener("click", this.hide);

        if(!this.hide) this.hide = function() {
            this.setState({ toggle: false });
            document.removeEventListener("click", this.hide);
        }.bind(this);

        this.setState({ toggle: true });
        document.addEventListener("click", this.hide);
    }

    handelOnclick(id , e){

        var columns = this.state.columns;
            columns[id].display = !columns[id].display;

        var displayTotal= 0;
        var HiddenTotal = 0;

        for(var idx = 0 ; idx < columns.length; idx++) {
            displayTotal = columns[idx].display ? displayTotal + 1 : 0;
            HiddenTotal  = !columns[idx].display ? HiddenTotal  + 1 : 0;
        }

        if(HiddenTotal == columns.length) columns[id].display = true;

        this.state.onColumnsUpdate(columns[id].id , columns[id].display);
        this.setState({columns: columns});

    }

    handelDownload(){
        (new Download()).export_table_to_csv();
    }

    renderChangeColumnsList(){
        var list = [];

        for(var idx = 0 ; idx < this.state.columns.length; idx++)
        {

            list.push(
                <li>
                    <div onChange={this.handelOnclick.bind(this , idx)}  className="checkbox">
                        <label className="dropdown-item" aria-disabled="false">
                            <input  checked={this.state.columns[idx].display} type="checkbox" className="dropdown-item-checkbox" />
                            <i className="input-helper"></i>
                            <div><FormattedMessage id={ String(this.state.columns[idx].translationsID || 0 )} defaultMessage={ this.state.columns[idx].defaultMessage || "" } /></div>
                        </label>
                    </div>
                </li>
            );
        }

        return list;
    }

    getAdditionalButtons() {
        var buttons = [];
        for (var x = 0;  x < this.state.additionalButtons.length; x++) {
            var button = this.state.additionalButtons[x];
            buttons.push(<div className="dropdown btn-group">
                <button onClick={button.action} className="btn btn-default btn-icon-text waves-effect table-td-button">
                    <i className={button.icon ? button.icon : ''}></i>{button.text}
                </button>
            </div>)
        }
        return buttons;
    }

    renderActions(){
        if(!this.state.enableActions) return;


        const changeCols = this.props.disableChangeCols ? null :  <div onClick={this.show.bind(this)} className={ this.state.toggle == true ? "dropdown btn-group open" : "dropdown btn-group" }><button className="btn btn-default btn-icon-text"><i className="zmdi zmdi-view-module"></i><FormattedMessage id={ String("ui-753")} defaultMessage={ "Change Columns" } /></button><ul className="dropdown-menu pull-right" role="menu">{ this.renderChangeColumnsList() }</ul></div>
        const download = <div className="dropdown btn-group"><button onClick={this.handelDownload.bind(this)} className="btn  btn-default b-btn-icon-text waves-effect"><i className="zmdi zmdi-download"></i><FormattedMessage id={ String("ui-473")} defaultMessage={ "Download spreadsheet" } /></button></div>
        return (<div className="actions btn-group pull-right">
            {this.getAdditionalButtons()}
            {changeCols}
            {download}
        </div>);
    }
    render(){
        return (
            <div className="bootgrid-header container-fluid">
                <div className="row">
                    <div className="col-sm-4 actionBar">
                        <TableSearchComponent onSearch={this.state.onSearch}/>
                    </div>
                    <div className="col-sm-8 actionBar hidden-xs">
                        {this.renderActions()}
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/table.controls.component.js